import React, { useState, useEffect } from 'react';

import {
	Cell,
	XAxis,
	YAxis,
	Tooltip,
	ResponsiveContainer,
	BarChart,
	Bar,
} from 'recharts';
import PropTypes from 'prop-types';
import moment from 'moment';
import { priceFormatter } from '~/helpers/price';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';

export function GraficoTopDias(props) {
	const { data, loading } = props;
	const [grafico, setGrafico] = useState([
		{
			name: '',
			value: 0,
		},
	]);

	useEffect(() => {
		const dataArray = [];
		for (let i = 0; i < data.length; i += 1) {
			dataArray.push({
				name: moment(data[i].data_transacao).format('DD/MM/YYYY'),
				value: data[i].valor_transacionado,
			});
		}
		setGrafico(dataArray);
	}, [data]);

	if (loading) {
		return (
			<div
				className="d-flex align-items-center justify-content-center"
				style={{ height: '400px' }}>
				<LoaderMini width="70" />
			</div>
		);
	}

	if (!loading && grafico.length === 0) {
		return <Text>Sem resultados no periodo</Text>;
	}

	return (
		<div style={{ width: '100%', height: 400, paddingTop: '40px' }}>
			<ResponsiveContainer>
				<BarChart height={400} data={grafico} layout="vertical">
					<XAxis
						type="number"
						dataKey="value"
						tickFormatter={(tick) => `R$ ${priceFormatter(tick)}`}
						stroke="black"
					/>
					<YAxis
						type="category"
						dataKey="name"
						tick={{ fontSize: 10 }}
						stroke="black"
					/>
					<Tooltip
						formatter={(value) => [
							`R$ ${priceFormatter(value)}`,
							'Valor',
						]}
					/>
					<Bar dataKey="value" barSize={40}>
						{grafico.map((entry) => (
							<Cell
								key={`cell-${entry}`}
								fill={color.secondary}
							/>
						))}
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
}

GraficoTopDias.propTypes = {
	data: PropTypes.oneOfType([PropTypes.array]),
	loading: PropTypes.bool.isRequired,
};

GraficoTopDias.defaultProps = {
	data: [],
};
